import React from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import ReactResumableJs from 'react-resumable-js';
import commonUtil from '../../utils/commonUtil';


const KALTURA_ADD = '/service/uploadToken/action/add';
const KALTURA_UPLOAD = '/service/uploadToken/action/upload';
const KALTURA_ADD_FROM_UPLOADED_FILE = '/service/media/action/addFromUploadedFile';

/* eslint-disable */
const KALTURA_MEDIATYPE_VIDEO = 1;  // eslint-disable-line no-unused-vars
const KALTURA_MEDIATYPE_IMAGE = 2;  // eslint-disable-line no-unused-vars
const KALTURA_MEDIATYPE_AUDIO = 3;  // eslint-disable-line no-unused-vars
/* eslint-enable */


export default class ReactKalturaResumableJs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lastUploadToken: null,
    };
  }

  _request = (path, queryString) => {
    const url = this.props.server + path + '?format=1&ks=' + this.props.ks + '&' + queryString;

    return new Promise((fulfill, reject) => {
      axios.post(url)
        .then(fulfill)
        .catch(reject);
    });
  };

  _addMedia = (file, message) => {      // eslint-disable-line no-unused-vars
    const path = KALTURA_ADD_FROM_UPLOADED_FILE;
    let queryString = 'mediaEntry:name=' + encodeURIComponent(file.uniqueIdentifier) + '&mediaEntry:mediaType=' + KALTURA_MEDIATYPE_IMAGE + '&uploadTokenId=' + this.state.lastUploadToken;


    if (this.props.categories.length > 0) {
      queryString += '&mediaEntry:categoriesIds=' + this.props.categories;
    }
    commonUtil.showApplicationLoader();

    this._request(path, queryString).then((response) => {
      if (typeof this.props.onFileSuccess === 'function') {
        commonUtil.hideApplicationLoader();
        this.props.onFileSuccess(response.data);
      }
    }).catch((reject) => {
      commonUtil.hideApplicationLoader();
      if (typeof this.props.onError === 'function') {
        this.props.onError(reject);
      }
    });
  };

  _uploadVideo = (file, tResumable) => {
    const resumable = tResumable;
    const minSize = 131072; // 128 KB
    if (file.size < minSize) {
      resumable.removeFile(file); // Remove the file from upload queue
      if (typeof this.props.onMinFileSizeErrorCallback === 'function') {
        this.props.onMinFileSizeErrorCallback(file);
      }
      return false; // prevent upload
    }
    
    file.bootstrap();

    commonUtil.showApplicationLoader();

    const chunksize = this.props.chunksize;

    resumable.opts.target = this.props.server + KALTURA_UPLOAD;
    resumable.opts.fileParameterName = 'fileData';
    resumable.opts.chunkSize = chunksize * 1024;
    resumable.opts.simultaneousUploads = this.props.simultaneousUploads;
    resumable.opts.testChunks = false;
    resumable.opts.throttleProgressCallbacks = 1;

    const queryString = 'uploadToken:objectType=KalturaUploadToken' +
      '&uploadToken:fileName=' + encodeURIComponent(file.fileName) +
      '&uploadToken:fileSize=' + file.size;

    this._request(KALTURA_ADD, queryString)
      .then((response) => {
        this.setState({
          lastUploadToken: response.data.id,
        });

        resumable.opts.query = (rFile, chunk) => ({
          format: 1,
          ks: this.props.ks,
          uploadTokenId: this.state.lastUploadToken,
          resume: chunk.offset > 0 ? 1 : 0,
          resumeAt: chunk.startByte,
          finalChunk: chunk.offset + 1 === rFile.chunks.length ? 1 : 0,
        });
        const previewContainer = Array.from(document.getElementsByClassName('resumable-list'));
 
        previewContainer && previewContainer.forEach(container => {
          container.style.display = "none";
        });
        resumable.upload();
        commonUtil.hideApplicationLoader();
      }).catch((reject) => {
        commonUtil.hideApplicationLoader();
        this.props.onError(reject);
      });
  };

  render() {
    return (
      <div>
        <ReactResumableJs
          uploaderID={this.props.uploaderID}
          dropTargetID="kalturaDropTarget"
          filetypes={this.props.filetypes}
          fileAccept={this.props.fileAccept}
          fileAddedMessage={this.props.fileAddedMessage}
          completedMessage={this.props.completedMessage}
          service={null}
          textLabel={this.props.textLabel}
          disableDragAndDrop
          onFileSuccess={this._addMedia}
          onFileAdded={this._uploadVideo}
          onFileRemoved={this.props.onFileRemoved}
          maxFileSize={this.props.maxFileSize}
          minFileSize={this.props.minFileSize}
          disableInput={this.props.disableInput}
          maxFiles={this.props.maxFiles}
          onFileAddedError={this.props.onFileAddedError}
          onMaxFileSizeErrorCallback={this.props.onMaxFileSizeErrorCallback}
          onMinFileSizeErrorCallback={this.props.onMinFileSizeErrorCallback}
          maxFilesErrorCallback={this.props.maxFilesErrorCallback}
        />
      </div>
    );
  }
}
/* eslint-disable */

ReactKalturaResumableJs.propTypes = {
  uploaderID: PropTypes.string.isRequired,
  filetypes: PropTypes.array,
  fileAccept: PropTypes.string,
  chunksize: PropTypes.number,
  simultaneousUploads: PropTypes.number,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onFileRemoved: PropTypes.func,
  textLabel: PropTypes.string,
  fileAddedMessage: PropTypes.string,
  completedMessage: PropTypes.string,
  maxFileSize: PropTypes.number,
  minFileSize: PropTypes.number,
  disableInput: PropTypes.bool,
  categories: PropTypes.string,
};
/* eslint-enable */

ReactKalturaResumableJs.defaultProps = {
  fileAccept: 'image/*',
  chunksize: 1024,
  maxFileSize: 6000000,
  minFileSize: 50000, // 100 MB aprox
  simultaneousUploads: 1,
  onError: error => error,
  onFileSuccess: success => success,
  onFileRemoved: file => file,
  uploaderID: 'Image-uploader',
  // textLabel: 'Sube una imagen de tu evento',
  fileAddedMessage: 'Started',
  completedMessage: 'Complete!:',
  disableInput: false,
  categories: '',
  maxFiles: 20,
  onMaxFileSizeErrorCallback: null,
};
